import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollBankExportDetail  {
    _originalTypeClassName = "zERP.BO.PayrollBankExportDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollBankExportDetail.translate = translateService;
}
this.Employees = [];
this.Id = null;
this.isAdvance = false;
this.IssueDate = null;
this.PaymentDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
isAdvance:any;
IssueDate:any;
PaymentDate:any;
BankFile:any;
BankExport:any;
Employees:any;
SubmissionBank:any;
static setBankFile = ($this, value) => {
var oldValue = $this.BankFile;
$this.BankFile = value;
if (value != null) {
}
}
static setBankExport = ($this, value) => {
var oldValue = $this.BankExport;
$this.BankExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollBankExport.removeDetails(oldValue, $this);
}
Domain.PayrollBankExport.addDetails(value, $this);
}
}
static setEmployees = ($this, items) => {
                if (items == null) items = [];
                if ($this.Employees == null) $this.Employees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Employees.length > 0) {
                    Domain.PayrollBankExportDetail.removeEmployees($this, $this.Employees[0]);
                }

                Domain.PayrollBankExportDetail.addManyEmployees($this, copyItems);
            }
static addManyEmployees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollBankExportDetail.addEmployees($this, items[i]);
                }
            }
static addEmployees = ($this, item) => {
                if ($this.Employees == null) $this.Employees = [];
                if (item == null || $this.Employees.indexOf(item) > -1) return;
                $this.Employees.push(item);
}
static addRangeEmployees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollBankExportDetail.addEmployees($this, item));
            }
static removeEmployees = ($this, item) => {
                if ($this == null || $this.Employees == null || $this.Employees.indexOf(item) === -1) return;
                var _index = $this.Employees.indexOf(item);
                $this.Employees.splice(_index, 1);
}
static clearEmployees = ($this) => { $this.Employees = null; }
static setSubmissionBank = ($this, value) => {
var oldValue = $this.SubmissionBank;
$this.SubmissionBank = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}